export default {
      id: "search-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.ece5aa3c.svg#search",
      toString: function () {
        return this.url;
      }
    }